import type {
  TAuthenticate,
  TChangePassword,
  TInitOtpSession,
  TOtpResend,
  TRefreshToken,
} from '@/types/auth';

import { identityService } from '@/api/public';
import { tokenUtils } from '@/tokenUtils';

export const resendOtp: TOtpResend = (data) => identityService.post('/public/otp/resend', data);

export const initOtpSession: TInitOtpSession = (data) =>
  identityService.post('/public/authorize', data, {
    params: {
      response_type: 'otp_session',
    },
  });

export const authenticate: TAuthenticate = ({ grantType, ...data }) =>
  identityService.post('/public/token', data, {
    params: {
      grant_type: grantType,
    },
  });

export const refreshToken: TRefreshToken = () =>
  identityService.post(
    '/public/token',
    {
      refreshToken: tokenUtils.getLocallyStoredRefreshToken(),
    },
    {
      params: {
        grant_type: 'refresh_token',
      },
    },
  );

export const changePassword: TChangePassword = ({ token, newPassword, oldPassword }) =>
  identityService.put(
    '/users/profile/password',
    { newPassword, oldPassword },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
